import { Component, OnInit, ChangeDetectorRef, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ListForm } from '../../../../base/controlers/list-form';
import { Decor } from '../../models/decor';
import { DecorService } from '../../services/decor.service';
import { PagedListForm } from '../../../../base/controlers/paged-list-form';
import { fromEvent } from 'rxjs';
import { filter, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';

@Component({
  selector: 'app-decor-list',
  templateUrl: './decor-list.component.html',
  styleUrls: ['./decor-list.component.css']
})
export class DecorListComponent extends PagedListForm<Decor> implements OnInit, AfterViewInit {
  public displayedColumns = ['actions','code','name', 'price'];
  @ViewChild('search',{static:true}) search: ElementRef;
  constructor(
    protected decorTypeService: DecorService,
    protected router:Router        
  ) {
    super(decorTypeService,'/plasard-measurement/decor',router,null,'code',true);    
   }

  ngOnInit() {
    super.ngOnInit();
  }
  ngAfterViewInit() {
    // server-side search
    fromEvent(this.search.nativeElement,'keyup')
        .pipe(
            filter(Boolean),
            debounceTime(300),
            distinctUntilChanged(),
            tap((_) => {
              const filter = this.search.nativeElement.value.trim();
              let query = null;
              if(filter){
                query = `contains(code, '${filter}') or contains(name, '${filter}')`;
              }
              this.onFilter(query);
            })
        )
        .subscribe();
    }  
}
